import { useCallback, useContext, useEffect, useState } from 'react'

import { AiOutlineCheckCircle, AiOutlinePlusCircle } from 'react-icons/ai'
import { FormattedMessage, useIntl } from 'react-intl'

import { FormacionIcon } from '../../Icons/CollaboratorsIcons'

import { getEmployee } from '../../API/Employee/Employee'
import { patchEnglishLevel } from '../../API/Employee/EnglishLevel'
import { deleteKnowledge, getKnowledge, postKnowledge, putKnowledge } from '../../API/Employee/Knowledge'

import { CompanyContext } from '../../Store/CompanyContext'

import { modalAssignTranslate, pagesDesc, personalInfoTranslate, wheelCollaboratorTranslate, employee_formation } from '../../i18n/translatedMessages'

import { Select } from './Components/Select/Select'
import Loading from '../../Components/Loading/Loading'
import ModalResponseStatus from '../../Components/ModalResponseStatus/ModalResponseStatus'

const typeOptionsES = [
	{ id: 'Técnico', value: 'Técnico' },
	{ id: 'Profesional', value: 'Profesional' },
	{ id: 'Diplomado', value: 'Diplomado' },
	{ id: 'MBA/Master', value: 'MBA/Master' },
	{ id: 'Doctorado', value: 'Doctorado' },
]

const typeOptionsPT = [
	{ id: 'Técnico', value: 'Técnico' },
	{ id: 'Profesional', value: 'Graduação' },
	{ id: 'Diplomado', value: 'Pós Graduação' },
	{ id: 'MBA/Master', value: 'MBA /Mestrado' },
	{ id: 'Doctorado', value: 'Doutorado' },
]

const monthsInSpanish = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

const monthsInPt = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julio', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

const InfoEducacion = () => {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const objEmpty = {
		id: null,
		university: '',
		type: '',
		course: '',
		startMonth: '',
		startYear: '',
		stillInProgress: false,
		endMonth: '',
		endYear: '',
	}
	const [changedLevel, setChangedLevel] = useState(false)
	const { store, actions } = useContext(CompanyContext)

	const [openIndex, setOpenIndex] = useState(null)

	const [englishLevel, setEnglishLevel] = useState('')

	const [educacionInfos, setEducacionInfos] = useState([objEmpty])
	const [loading, setLoading] = useState(false)
	const [loadingSendingData, setLoadingSendingData] = useState(false)

	const typeOptions = language === 'es' ? typeOptionsES : typeOptionsPT

	const handleAccordionClick = index => {
		if (!loading) setOpenIndex(prevIndex => (prevIndex === index ? null : index))
	}

	const getRequest = useCallback(async () => {
		try {
			setLoading(true)
			const users = JSON.parse(localStorage.getItem('user'))
			const know = await getKnowledge(users.id)
			const knowSort = know.sort((x, y) => (x.endYear * 12 + x.endMonth > y.endYear * 12 + y.endMonth ? -1 : 1))

			const transformedData = knowSort.map(item => {
				const isInProgress = !item.endMonth || !item.endYear || item.endMonth === null || item.endYear === null

				return {
					...item,
					startMonth: item.startMonth ? { id: item.startMonth, value: item.startMonth } : { id: '', value: '' },
					endMonth: item.endMonth ? { id: item.endMonth, value: item.endMonth } : { id: '', value: '' },
					startYear: item.startYear ? { id: item.startYear, value: item.startYear } : { id: '', value: '' },
					endYear: item.endYear ? { id: item.endYear, value: item.endYear } : { id: '', value: '' },
					type: typeOptions.find(option => option.id === item.type) || { id: '', value: '' },
					inProgress: isInProgress,
				}
			})

			setEducacionInfos(transformedData.length > 0 ? transformedData : [objEmpty])
			const employeeDataAux = await getEmployee(users.id)
			setEnglishLevel(employeeDataAux ? employeeDataAux.englishLevel : '')
			setOpenIndex(null)
			setLoading(false)
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		getRequest()
	}, [getRequest])

	const handleSubmit = async (e, index, currentId) => {
		setLoadingSendingData(true)
		const user = JSON.parse(localStorage.getItem('user'))

		const itemToSend = {
			university: educacionInfos[index].university,
			type: educacionInfos[index].type?.value,
			course: educacionInfos[index].course,
			startMonth: educacionInfos[index].startMonth?.value,
			startYear: educacionInfos[index].startYear?.value,
			endMonth: educacionInfos[index].inProgress ? null : educacionInfos[index].endMonth?.value,
			endYear: educacionInfos[index].inProgress ? null : educacionInfos[index].endYear?.value,
			employerId: user.id,
		}

		const handleResponse = (status, successMessage) => {
			if (status >= 200 && status <= 299) {
				actions.setResponseStatus(true)
				actions.setMessageResponseStatus(successMessage)
			} else {
				throw new Error('Error on save, try again')
			}
			actions.setShowModalResponseStatus(true)
		}

		try {
			const response = currentId ? await putKnowledge(itemToSend, currentId) : await postKnowledge([itemToSend])
			getRequest()
			handleResponse(response.status, 'Éxito')
		} catch (error) {
			actions.setResponseStatus(false)
			actions.setMessageResponseStatus('Ha ocurrido un error!')
			actions.setShowModalResponseStatus(true)
		} finally {
			setLoadingSendingData(false)
		}
	}

	const handleChangeEnglishLevel = async e => {
		setEnglishLevel(e.currentTarget.value)
		setChangedLevel(true)
	}

	const handleSendEnglishLevel = async () => {
		const user = JSON.parse(localStorage.getItem('user'))
		await patchEnglishLevel(user.id, { englishLevel })
	}

	const handleAdd = () => {
		setEducacionInfos([...educacionInfos, { ...objEmpty }])
	}

	const handleRemove = async (e, index, id) => {
		try {
			setLoadingSendingData(true)
			await deleteKnowledge(id)
			const newEducacionInfos = [...educacionInfos]
			newEducacionInfos.splice(index, 1)
			setEducacionInfos(newEducacionInfos)
			setOpenIndex(null)
		} catch (error) {
			console.error('Erro ao excluir o item:', error)
		} finally {
			setLoadingSendingData(false)
		}
	}

	const handleClose = () => {
		actions.setShowModalResponseStatus(false)
	}

	function handleSelect(e, type, index) {
		const updatedEducacionInfos = [...educacionInfos]

		updatedEducacionInfos[index] = {
			...updatedEducacionInfos[index],
			[type]: { id: e.id, value: e.value },
		}

		setEducacionInfos(updatedEducacionInfos)
	}

	const months = Array.from({ length: 12 }, (_, index) => ({
		id: (index + 1).toString(),
		value: (index + 1).toString(),
	}))

	const years = Array.from({ length: 56 }, (_, index) => ({
		id: (2024 - index).toString(),
		value: (2024 - index).toString(),
	}))

	const handleInputChange = (index, field, value) => {
		const updatedEducacionInfos = [...educacionInfos]
		updatedEducacionInfos[index] = {
			...updatedEducacionInfos[index],
			[field]: value,
		}
		setEducacionInfos(updatedEducacionInfos)
	}

	const getMonthTranslate = monthNumber => {
		if (language === 'es') return monthsInSpanish[monthNumber - 1]
		else return monthsInPt[monthNumber - 1]
	}

	const isSaveDisabled = index => {
		const item = educacionInfos[index]
		const { university, type, course, startMonth, startYear, endMonth, endYear, inProgress } = item

		const isRequiredFieldsFilled = university && type && course && startMonth && startYear

		if (endYear && startYear && endYear.value && startYear.value && endYear.value < startYear.value) {
			return true
		}

		if (
			endYear &&
			startYear &&
			endYear.value === startYear.value &&
			endMonth &&
			startMonth &&
			endMonth.value &&
			startMonth.value &&
			endMonth.value < startMonth.value
		) {
			return true
		}

		if (!inProgress) {
			return !(isRequiredFieldsFilled && endMonth && endYear && endMonth.value && endYear.value)
		}

		return !isRequiredFieldsFilled
	}

	return (
		<div className='container-fluid'>
			<FormattedMessage id={'nextButton'}>
				{msg => (
					<ModalResponseStatus
						show={store.showModalResponseStatus}
						handleClose={handleClose}
						message={store.messageResponseStatus}
						successMessage={store.responseStatus}
						btnRight={msg}
					/>
				)}
			</FormattedMessage>
			<div className='row mb-4'>
				<div className='col-1'>
					<span className='title-icon p-2 m-auto'>
						<FormacionIcon size={20} />
					</span>
				</div>
				<div className='col-8'>
					<h1>{wheelCollaboratorTranslate.formation}</h1>
				</div>
				<div className='mt-4'>{pagesDesc.formationDesc}</div>
			</div>
			{loading ? (
				<Loading />
			) : (
				<>
					<div className='row justify-content-center'>
						<div className='col-12 pt-4'>
							<p>
								<strong>{personalInfoTranslate.personalEnglishLevel}</strong>
							</p>
							<div className='form-check form-check-inline'>
								<input
									className='form-check-input'
									type='radio'
									name='englishLevel'
									id='englishLevel0'
									value='Nulo'
									onChange={handleChangeEnglishLevel}
									checked={englishLevel === 'Nulo'}
								/>
								<label className='form-check-label' htmlFor='englishLevel0'>
									{personalInfoTranslate.personalELNulo}
								</label>
							</div>
							<div className='form-check form-check-inline'>
								<input
									className='form-check-input'
									type='radio'
									name='englishLevel'
									id='englishLevel1'
									value='Basico'
									onChange={handleChangeEnglishLevel}
									checked={englishLevel === 'Basico'}
								/>
								<label className='form-check-label' htmlFor='englishLevel1'>
									{personalInfoTranslate.personalELBasic}
								</label>
							</div>
							<div className='form-check form-check-inline'>
								<input
									className='form-check-input'
									type='radio'
									name='englishLevel'
									id='englishLevel2'
									value='Intermedio'
									onChange={handleChangeEnglishLevel}
									checked={englishLevel === 'Intermedio'}
								/>
								<label className='form-check-label' htmlFor='englishLevel2'>
									{personalInfoTranslate.personalELAverage}
								</label>
							</div>
							<div className='form-check form-check-inline'>
								<input
									className='form-check-input'
									type='radio'
									name='englishLevel'
									id='englishLevel3'
									value='Avanzado'
									onChange={handleChangeEnglishLevel}
									checked={englishLevel === 'Avanzado'}
								/>
								<label className='form-check-label' htmlFor='englishLevel3'>
									{personalInfoTranslate.personalELAdvanced}
								</label>
							</div>
							<div className='form-check form-check-inline'>
								<input
									className='form-check-input'
									type='radio'
									name='englishLevel'
									id='englishLevel4'
									value='Fluido'
									onChange={handleChangeEnglishLevel}
									checked={englishLevel === 'Fluido'}
								/>
								<label className='form-check-label' htmlFor='englishLevel4'>
									{personalInfoTranslate.personalELFluent}
								</label>
							</div>
							<div className='form-check form-check-inline'>
								{changedLevel && (
									<button className='btn btn-saveinfo rounded-pill bg-blue' onClick={handleSendEnglishLevel}>
										{modalAssignTranslate.btnSave} <AiOutlineCheckCircle size={25} />
									</button>
								)}
							</div>
						</div>
						<div className='col-12 text-end'>
							<button className='btn rounded-pill addEmployeeInfo-btn' onClick={handleAdd}>
								Add <AiOutlinePlusCircle size={25} />
							</button>
						</div>
					</div>

					<div className='border tw-rounded-md tw-shadow-md tw-mt-5'>
						{educacionInfos.map((info, index) => (
							<div key={index} className=''>
								<div
									onClick={() => handleAccordionClick(index)}
									className={`border-bottom tw-w-full tw-text-left tw-items-center tw-flex tw-p-4 tw-h-[60px] ${
										index === openIndex ? 'tw-bg-purple tw-text-white' : 'tw-bg-white'
									}`}
								>
									{info.id || info.course ? (
										<div className='tw-font-bold tw-text-base'>
											{info.course} - {info.university} -{' '}
											{info.startMonth?.value && info.startYear?.value && (
												<>
													{getMonthTranslate(info.startMonth.value)}/{info.startYear.value}{' '}
												</>
											)}
											{info.endMonth?.value && info.endYear?.value && (
												<>
													{' - '}
													{getMonthTranslate(info.endMonth.value)}/{info.endYear.value}
												</>
											)}
											{info.inProgress && <> - En curso</>}
										</div>
									) : (
										<div className='tw-font-bold tw-text-base'>{employee_formation.fomation_new}</div>
									)}
								</div>
								<div
									className={`tw-overflow-hidden tw-flex tw-justify-center tw-flex-col tw-space-y-9  tw-transition-all tw-bg-gray-50 ${
										index === openIndex ? 'tw-h-[400px] tw-p-4' : 'tw-max-h-0'
									}`}
								>
									{loadingSendingData ? (
										<div className='tw-h-[200px] tw-flex tw-justify-center tw-items-center'>
											<Loading />
										</div>
									) : (
										<>
											<div className='tw-grid tw-grid-cols-3 tw-gap-2'>
												<div className='div'>
													<p className='tw-mb-1'>{employee_formation.fomation_university_name}</p>
													<input
														className='border border-1 tw-rounded-lg tw-border tw-p-2 tw-w-full'
														placeholder=''
														value={info.university || ''}
														onChange={e => handleInputChange(index, 'university', e.target.value)}
													/>
												</div>
												<div className='div'>
													<p className='tw-mb-1'>{employee_formation.fomation_type}</p>
													<div className='tw-bg-white'>
														<Select
															list={typeOptions}
															option={info.type?.value || info.type}
															onChange={e => handleSelect(e, 'type', index)}
															placeholder='Nivel de Graduacao'
															maxHeight={'210px'}
														/>
													</div>
												</div>
												<div className='div'>
													<p className='tw-mb-1'>{employee_formation.fomation_career}</p>
													<input
														className='border border-1 tw-rounded-lg tw-border tw-p-2 tw-w-full'
														placeholder=''
														value={info.course || ''}
														onChange={e => handleInputChange(index, 'course', e.target.value)}
													/>
												</div>
											</div>

											<div className='tw-grid tw-grid-cols-3 tw-gap-2 tw-mb-5 tw-pb-5 '>
												<div className=''>
													<p className='tw-mb-1'>{employee_formation.fomation_admission_date}</p>
													<div className='tw-grid tw-grid-cols-2 tw-gap-2'>
														<div className='tw-bg-white'>
															<Select
																list={months}
																option={info.startMonth?.value || info.startMonth}
																onChange={e => handleSelect(e, 'startMonth', index)}
																placeholder='Mes'
																maxHeight={'145px'}
															/>
														</div>
														<div className='tw-bg-white'>
															<Select
																list={years}
																option={info.startYear?.value || info.startYear}
																onChange={e => handleSelect(e, 'startYear', index)}
																placeholder='Ano'
																maxHeight={'145px'}
															/>
														</div>
													</div>
												</div>
												{!info.inProgress ? (
													<div>
														<p className='tw-mb-1'>{employee_formation.fomation_graduation_date}</p>
														<div className='tw-grid tw-grid-cols-2 tw-gap-2'>
															<div className='tw-bg-white'>
																<Select
																	list={months}
																	option={info.endMonth?.value || info.endMonth}
																	onChange={e => handleSelect(e, 'endMonth', index)}
																	placeholder='Mes'
																	maxHeight={'145px'}
																/>
															</div>
															<div className='tw-bg-white'>
																<Select
																	list={years}
																	option={info.endYear?.value || info.endYear}
																	onChange={e => handleSelect(e, 'endYear', index)}
																	placeholder='Ano'
																	maxHeight={'145px'}
																/>
															</div>
														</div>
													</div>
												) : (
													<div className='tw-hidden sm:tw-block' />
												)}
												<div className='tw-mb-2 tw-flex tw-items-center tw-mt-4 tw-pt-4'>
													<input
														type='checkbox'
														checked={info.inProgress || false}
														onChange={() => {
															setEducacionInfos(prevInfos => {
																const updatedInfos = [...prevInfos]
																updatedInfos[index] = {
																	...updatedInfos[index],
																	inProgress: !updatedInfos[index].inProgress,
																	endMonth: !updatedInfos[index].inProgress ? null : updatedInfos[index].endMonth,
																	endYear: !updatedInfos[index].inProgress ? null : updatedInfos[index].endYear,
																}
																if (!updatedInfos[index].inProgress) {
																	updatedInfos[index].endMonth = null
																	updatedInfos[index].endYear = null
																}
																return updatedInfos
															})
														}}
													/>
													<span className='tw-text-base tw-pl-2 tw-text-gray-700'>{employee_formation.fomation_ongoing}</span>
												</div>
											</div>

											<div className='tw-mb-2 tw-pt-5 tw-flex tw-items-end  tw-justify-end'>
												<div
													onClick={e => handleRemove(e, index, info.id)}
													className='tw-bg-error-500 tw-rounded-xl tw-text-white tw-px-4 tw-py-2 tw-mr-4 hover:tw-bg-error-600'
												>
													{employee_formation.fomation_delete}
												</div>
												<button
													onClick={e => handleSubmit(e, index, info.id)}
													className={`tw-bg-green-500 tw-rounded-xl border-0 tw-text-white tw-px-4 tw-py-2  ${
														isSaveDisabled(index) ? 'tw-opacity-50' : 'hover:tw-bg-green-600'
													}`}
													disabled={isSaveDisabled(index)}
												>
													{employee_formation.fomation_save}
												</button>
											</div>
										</>
									)}
								</div>
							</div>
						))}
					</div>
				</>
			)}
		</div>
	)
}

export default InfoEducacion
